import api from "../../../services/api";

export interface PaymentLinkInfo {
  firstName: string;
  lastName: string;
  email: string;
  opticianName: string;
  description: string;
  amountHtCents: number;
  vatCents: number;
  amountTtcCents: number;
  currency: string;
  status: "pending" | "paid" | "cancelled";
  paidAt: string | null;
  expiresAt: string;
}

export interface PayResponse {
  success?: boolean;
  message?: string;
  redirectUrl?: string;
  requires_action?: boolean;
  payment_intent_client_secret?: string;
  payment_intent_id?: string;
}

export const fetchPaymentLinkInfo = async (token: string): Promise<PaymentLinkInfo> => {
  const { data } = await api.get(`/payment-link/${token}`);
  return data;
};

export const payPaymentLink = async (
  token: string,
  body: { cardPaymentMethodId: string }
): Promise<PayResponse> => {
  const { data } = await api.post(`/payment-link/${token}/pay`, body);
  return data;
};

export const confirm3dsPaymentLink = async (
  token: string,
  body: { paymentIntentId: string }
): Promise<PayResponse> => {
  const { data } = await api.post(`/payment-link/${token}/confirm-3ds`, body);
  return data;
};
